import { createReducer } from '@reduxjs/toolkit';

import * as textActions from './textActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'text',
  isActive: false,

  content: '',
};

const text = createReducer(initialState, (builder) => {
  builder
    .addCase(textActions.textUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(textActions.textUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(textActions.textStore, (state, { payload: data }) => {
      const {
        blockId,
        uid,
        isActive,

        text,
      } = data;

      const section = text ?? {};
      const { content } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: blockId ?? 0,
        uid: uid ?? 0,
        isActive: isActive,

        content: content ?? '',
      };
    })
    .addCase(textActions.textClear, () => ({ ...initialState }))

    .addCase(textActions.textUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(textActions.textUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(textActions.textUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(textActions.textUpdateContent, (state, { payload: content }) => ({ ...state, content }));
});

export default text;
